import { render, staticRenderFns } from "./SelectedDistrictTitle.vue?vue&type=template&id=59d5eb5c&scoped=true&"
import script from "./SelectedDistrictTitle.vue?vue&type=script&lang=js&"
export * from "./SelectedDistrictTitle.vue?vue&type=script&lang=js&"
import style0 from "./SelectedDistrictTitle.vue?vue&type=style&index=0&id=59d5eb5c&scoped=true&lang=css&"
import style1 from "./SelectedDistrictTitle.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d5eb5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
